import { render, staticRenderFns } from "./FormDataList.vue?vue&type=template&id=2268fd88&"
import script from "./FormDataList.vue?vue&type=script&lang=js&"
export * from "./FormDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports